import React from 'react';

import { Form, Radio } from 'antd';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { formatAreaByUnitSystem, getAreaUnitLabel } from 'utils/helpers/units';

import { useCMASummaryRoomTypeFilterContext } from './CMASummaryRoomTypeFilterContext';
import {
  CMA_SUMMARY_ROOM_COMPARISON_SQFT_RANGE_OPTIONS,
  CMA_SUMMARY_ROOM_TYPE_FILTER_COMPARISON_OPTIONS,
} from '../../constants';
import RectangularSelect from '../components/RectangularSelect';

const ComparisonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 22px 20px;
  border-top: 1px solid var(--line-gray);
`;

const ComparisonTitle = styled.span`
  font-family: var(--font-bold);
`;

const ComparisonRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 14px;

  .ant-radio-wrapper {
    display: flex;
    align-items: center;
    margin: 0;
    font-size: 14px;
  }
`;

const ComparisonOption = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`;

const ComparisonCheckbox = styled(Checkbox)`
  font-size: 14px;
  padding-left: 26px;
`;

const CMASummaryRoomTypeFilterComparison = () => {
  const { form } = useCMASummaryRoomTypeFilterContext();
  const { community } = useCommunityViewContext();
  const comparisonType = Form.useWatch('comparisonType', form);

  const isAdvancedSelected = comparisonType === CMA_SUMMARY_ROOM_TYPE_FILTER_COMPARISON_OPTIONS.BY_ROOM_TYPE_AND_SQFT;
  const areaUnitLabel = getAreaUnitLabel(community);
  const rangeOptions = CMA_SUMMARY_ROOM_COMPARISON_SQFT_RANGE_OPTIONS.map((option) => ({
    ...option,
    label: `${formatAreaByUnitSystem(option.value, community)} ${areaUnitLabel}`,
  }));

  return (
    <ComparisonContainer>
      <ComparisonTitle>COMPARISON TYPE</ComparisonTitle>
      <Form.Item name="comparisonType">
        <ComparisonRadioGroup>
          <Radio value={CMA_SUMMARY_ROOM_TYPE_FILTER_COMPARISON_OPTIONS.BY_ROOM_TYPE}>By room type</Radio>
          <ComparisonOption>
            <Radio value={CMA_SUMMARY_ROOM_TYPE_FILTER_COMPARISON_OPTIONS.BY_ROOM_TYPE_AND_SQFT}>
              <span>By both room type and {areaUnitLabel} within:</span>
            </Radio>
            <Form.Item name="comparisonSqftRange" noStyle>
              <RectangularSelect
                disabled={!isAdvancedSelected}
                style={{ width: 100, height: 36, borderRadius: 0 }}
                options={rangeOptions}
              />
            </Form.Item>
          </ComparisonOption>
        </ComparisonRadioGroup>
      </Form.Item>
      <Form.Item name="showClosestBeyondRange" valuePropName="checked">
        <ComparisonCheckbox className="green" disabled={!isAdvancedSelected}>
          Show closest room types beyond selected value
        </ComparisonCheckbox>
      </Form.Item>
    </ComparisonContainer>
  );
};

export default CMASummaryRoomTypeFilterComparison;
